module.exports = __webpack_public_path__ + "img/linkedin.f451df4c.png";